import PropTypes from 'prop-types';

// mantine
import { Group, Box, ActionIcon } from '@mantine/core';
import { IconMenu2 } from '@tabler/icons-react';

// project imports
import { useMatches } from 'hooks/use-responsive';
import NotificationBell from './NotificationBell';
import ThemeToggle from 'theme/ThemeToggle';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
  const isDesktop = useMatches({ base: false, md: true });

  return (
    <Group justify="space-between" h="100%" w="100%" px="md" wrap="nowrap">
      {/* Desktop: logo left-aligned, clickable to toggle sidebar */}
      {isDesktop ? (
        <Box
          component="span"
          role="button"
          tabIndex={0}
          aria-label="Toggle sidebar"
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          onClick={handleLeftDrawerToggle}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleLeftDrawerToggle();
            }
          }}
        >
          <img
            src="https://driptours.com/wp-content/themes/picostrap5-child-base/assets/images/DT-logo.png"
            alt="Logo"
            style={{ maxWidth: '100%', height: 'auto', maxHeight: 48, paddingTop: 4 }}
          />
        </Box>
      ) : (
        /* Mobile: logo + notification bell + hamburger */
        <Group justify="space-between" w="100%" wrap="nowrap">
          <Box
            component="img"
            src="https://driptours.com/wp-content/themes/picostrap5-child-base/assets/images/DT-logo.png"
            alt="Logo"
            role="button"
            tabIndex={0}
            onClick={handleLeftDrawerToggle}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleLeftDrawerToggle();
              }
            }}
            style={{ maxWidth: 140, height: 'auto', cursor: 'pointer' }}
          />
          <Group gap={4} wrap="nowrap">
            <ThemeToggle />
            <NotificationBell />
            <ActionIcon variant="subtle" size="lg" aria-label="Open menu" onClick={handleLeftDrawerToggle} color="coral">
              <IconMenu2 size={24} />
            </ActionIcon>
          </Group>
        </Group>
      )}

      {/* Spacer (desktop only) */}
      {isDesktop && <Box style={{ flexGrow: 1 }} />}

      {/* Desktop notification bell */}
      {isDesktop && (
        <Group gap="sm">
          <ThemeToggle />
          <NotificationBell />
        </Group>
      )}
    </Group>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
